import { env } from '../env';
import { getSubdomainName } from './getSubdomainName';

export const getXhostHeader = (): string | undefined => {
  const subdomain = getSubdomainName();
  if (!subdomain) {
    return undefined;
  }
  return `${subdomain}.${env.VITE_API_DOMAIN}`;
};
